import { render, staticRenderFns } from "./standardTestReport.vue?vue&type=template&id=481f73b4&scoped=true&"
import script from "./standardTestReport.vue?vue&type=script&lang=js&"
export * from "./standardTestReport.vue?vue&type=script&lang=js&"
import style0 from "./standardTestReport.vue?vue&type=style&index=0&id=481f73b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481f73b4",
  null
  
)

export default component.exports